import { FarmStatusDtoValueEnum } from "api";

export const isFarmPending = (status: FarmStatusDtoValueEnum): boolean =>
  status === FarmStatusDtoValueEnum.NeedsReview;
